import { post } from '@/common/request';

const enumsMap = new Map([
  ['list', '/tenant/init/enums'],
  ['categoryList', '/category/list'],
]);

export default enumsMap;

interface Enum {
  [key: string]: {value: string | number, label: string}[]
}


export async function getList(labelList: any): Promise<Enum> {
  const result: { [key: string]: {value: string | number, name: string}[] } = await post('/tenant/init/enums', { labelList }, { needCancel: false, proxyApi: '/resserv' });
  for (const key of Object.keys(result)) {
    result[key] = result[key].map(item => {
      const { name, value } = item;
      return {
        label: name,
        value
      };
    }) as any;
  }
  return result as any;
}

/**
 * 枚举下拉框接口（批量查询）
 * https://yapi.lanhanba.com/project/399/interface/api/39444
 */
export async function getInitEnums(params?: any) {
  return post('/tenant/init/enums', params, { proxyApi: '/resserv', needHint: true, needCancel: false });
}

/**
 * 类目列表
 * https://yapi.lanhanba.com/project/399/interface/api/51197
 */
export async function getCategoryList(params?: any) {
  return post('/tenant/category/list', params, { proxyApi: '/resserv', needHint: true, needCancel: false });
}

/**
 * 场地范围内的类型列表
 * https://yapi.lanhanba.com/project/319/interface/api/54249
 */
export async function getPlaceCategoryList(params?: any) {
  return post('/property/place/category', params, { needHint: true, needCancel: false });
}

/**
 * 获取页面状态选项
 * https://yapi.lanhanba.com/project/319/interface/api/91090
 */
export async function postPageStatusOptions() {
  return post('/property/place/pageStatusOptions', {}, { needHint: true, needCancel: false });
}

